import Service from '@ember/service';

import { storageFor } from 'ember-local-storage';

import { isObject } from 'rise-ui/utils/object.js';

export default class TimeSeriesQueriesService extends Service {
  @storageFor('time-series-queries') queries;

  /**
   * Get all queries with matching name or href
   * @param {{name?:string,href?:string}} query Query object partial
   */
  getAll(query) {
    query = isObject(query) ? query : { name: query };
    const href = query.href || window.location.href;
    return this.queries.filter(s =>
      s.href === href || s.name === query.name
    );
  }
  get(query) {
    return this.getAll(query)[0];
  }
  getByUrl(href) {
    href = href || window.location.href;
    return this.queries.find(s => s.href === href);
  }
  getByName(name) {
    return this.queries.find(s => s.name === name);
  }
  clear() {
    this.queries.clear();
  }
  /**
   * Save query; replacing all queries with matching name or href
   * @param {string|{name:string,href?:string}} query Name or query object
   */
  save(query) {
    query = query && query.name ? query : { name: query };
    if (!query.name) {
      throw new Error('Expected name for saved query');
    }
    query.href = query.href || window.location.href;
    this.delete(query);
    this.queries.unshiftObject(query);
  }
  /**
   * Delete all queries with matching name or href
   * @param {{name?:string,href?:string}} query Query object partial
   */
  delete(query) {
    this.queries.removeObjects(this.getAll(query));
  }
}
